import React from "react";

const halflogoicon = React.forwardRef(
  (
    { width = "19", height = "18", viewBox = "0 0 19 18", fill = "none", className, ...props },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.20136 0.040959C9.14429 -0.0315833 10.7585 0.0143292 11.7446 0.0143292L18.301 0.0212353C18.0899 1.30429 17.6968 2.59662 16.7474 3.53299C15.2198 5.03963 13.5323 4.90041 11.5928 4.90041C9.95392 4.90494 6.02393 4.70085 4.62712 5.14389C3.84263 5.39268 3.22655 5.8171 2.61328 6.34915C3.09284 4.783 3.05699 3.29426 4.2796 1.88352C5.38282 0.610413 6.59885 0.197093 8.20136 0.040959Z"
          fill="#00B558"
        />
        <path
          d="M6.24495 6.67007C7.0222 6.60012 8.5836 6.64488 9.42924 6.64587L15.4799 6.64621C15.1267 7.93545 15.0495 8.90059 13.9623 9.95895C12.6676 11.2194 11.3023 11.1607 9.66991 11.1465L6.11296 11.1401C5.32649 11.1394 4.0494 11.1109 3.31989 11.2603C2.58419 11.4047 1.8886 11.707 1.28125 12.1465C1.67264 10.7913 1.77811 9.54519 2.73535 8.38236C3.72979 7.17439 4.76317 6.82306 6.24495 6.67007Z"
          fill="#00B558"
        />
        <path
          d="M3.49617 12.7998C4.10784 12.733 5.64719 12.7788 6.30803 12.781C5.92946 14.9353 5.39636 16.627 2.97335 17.0856C2.21207 17.1809 0.797357 17.1395 0 17.1382C0.0856916 16.8815 0.176686 16.4935 0.232101 16.2257C0.628901 14.3061 1.43996 13.0658 3.49617 12.7998Z"
          fill="#00B558"
        />
      </svg>
    );
  },
);

halflogoicon.displayName = "halflogoicon";

export default halflogoicon;
